// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"k1-z","displaySixCardTiles":"l1-z"};